module.exports = __webpack_public_path__ + "img/zhaokang.1cbf457e.jpg";